module.exports = __webpack_public_path__ + "media/images/sculpture-217983c3d931201dc42c1a77e7d3e279.svg";